import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { SystemUserService } from '../_services/system-user.service';

@Directive({
  selector: '[appWebSocketAccess]'
})
export class WebSocketAccessDirective implements OnInit {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private systemUserService: SystemUserService
  ) {}

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    const hasAccess = this.systemUserService.isSystemUser();

    if (hasAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
